'use strict';

class Page {
  constructor ( title, content ) {
    this.title   = title;
    this.content = content;
  }

  get slug () {
    return this.title.replace(/^\s+|\s+$/g, '')
               .toLowerCase()
               .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
               .replace(/\s+/g, '-') // collapse whitespace and replace by -
               .replace(/-+/g, '-'); // collapse dashes
  }
}

export default Page;
